const ALNUM = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

const ENTITY_PREFIXES: Record<string, string> = {
  task: 'TK',
  epic: 'EP',
  story: 'ST',
  sprint: 'SP',
  retrospective: 'RT',
  report: 'RP',
  cost: 'CI',
  requirement: 'RQ',
};

export const normalizeEntityId = (value: string): string => {
  return String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, '');
};

const randomAlnum = (length: number): string => {
  let out = '';

  for (let i = 0; i < length; i += 1) {
    const index = Math.floor(Math.random() * ALNUM.length);
    out += ALNUM[index];
  }

  return out;
};

const getPrefix = (entityType: string): string => {
  const explicit = ENTITY_PREFIXES[entityType];
  if (explicit) {
    return explicit;
  }

  const lettersOnly = entityType.toUpperCase().replace(/[^A-Z]/g, '');
  if (lettersOnly.length >= 2) {
    return lettersOnly.slice(0, 2);
  }

  if (lettersOnly.length === 1) {
    return `${lettersOnly}X`;
  }

  return 'ID';
};

export const generateAutoEntityId = (
  entityType: string,
  existingIds: string[] = [],
  suffixLength = 4
): string => {
  const normalizedExistingIds = new Set(existingIds.map(normalizeEntityId).filter(Boolean));
  const prefix = getPrefix(entityType);

  let candidate = `${prefix}-${randomAlnum(Math.max(2, suffixLength))}`;

  while (normalizedExistingIds.has(candidate)) {
    candidate = `${prefix}-${randomAlnum(Math.max(2, suffixLength))}`;
  }

  return candidate;
};

export const hasDuplicateEntityId = (
  candidateId: string,
  existingIds: string[],
  currentId?: string
): boolean => {
  const normalizedCandidate = normalizeEntityId(candidateId);
  const normalizedCurrent = normalizeEntityId(String(currentId || ''));

  if (!normalizedCandidate) {
    return false;
  }

  return existingIds
    .map(normalizeEntityId)
    .filter((value) => value && value !== normalizedCurrent)
    .includes(normalizedCandidate);
};
